/**
 * Theme Toggle Component
 * Displays a toggle button to switch between dark and light themes
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../../shared/hooks';
import { globalActions } from '../../../../../shared/store/globalSlice';
import type { RootState } from '../../../../../shared/types';

import styles from './ThemeToggle.module.css';

export type ThemeToggleProps = Record<string, never>;

/** Theme Toggle component for switching between dark and light modes */
function ThemeToggle(): React.ReactElement {
  const dispatch = useDispatch();
  const localize = useInvertedLocalize();
  const { dataTheme } = useSelector((state: RootState) => state.aag.global);

  const handleToggleTheme = (): void => {
    const newTheme = dataTheme === 'dark' ? 'light' : 'dark';

    dispatch(globalActions.setDataTheme(newTheme));
    // Persist to localStorage
    localStorage.setItem('li-theme', newTheme);
  };

  return (
    <button
      className={styles.themeToggleBtn}
      onClick={handleToggleTheme}
      type='button'
      aria-label={`Switch to ${dataTheme === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${dataTheme === 'dark' ? 'light' : 'dark'} mode`}>
      <div className={styles.themeToggleBtnContent}>
        <Icon
          kind={dataTheme === 'dark' ? 'Light' : 'Dark'}
          size='small'
          className={styles.themeIcon}
        />
        <span className={styles.themeLabel}>
          {dataTheme === 'dark' ? 'Light' : 'Dark'} {localize('Mode')}
        </span>
      </div>
    </button>
  );
}

export default ThemeToggle;
